export default __webpack_public_path__ + "static/media/image_placeholder.8b58bc47.jpg";